<template>
  <div class="department-option">
    <div class="department-option--icon" :class="{ 'is-checked': department.checked }">
      <x-svg-icon :name="(selectType === 'SINGLE' ? 'radio' : 'checkbox') + (department.checked ? '-active' : '')"></x-svg-icon>
    </div>
    <div class="department-option--info">
      <span class="department-option--name text-ellipsis">{{ department.name }}</span>
      <slot name="suffix"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    department: {
      type: Object,
      default() {
        return {}
      }
    },
    selectType: {
      type: String,
      default: 'SINGLE' // MULTI
    }
  }
}
</script>

<style lang="scss">
.department-option {
  display: flex;
  align-items: center;
  height: 3.57rem;
  background-color: $--app-box-bgColor;
  &:last-child {
    .department-option--info {
      border-bottom: 0;
    }
  }
  .department-option--icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 3.43rem;
    color: $--app-notice-color;
    &.is-checked {
      color: $--app-primary-color;
    }
  }
  .department-option--info {
    flex: 1;
    display: flex;
    align-items: center;
    height: 100%;
    border-bottom: 1px solid $--app-info-color;
    .department-option--name {
      flex: 1;
    }
  }
}
</style>
